import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, toRefs } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    url: { type: String, required: true },
    poster: { type: String, required: false },
    controls: { type: Boolean, required: false, default: true },
    cover: { type: Boolean, required: false, default: false }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as { url: string, poster?: string, controls: boolean, cover: boolean }



const poster = toRefs(props).poster;

const type = ref("video");

if (props.url.includes("vimeo")) {
    type.value = "vimeo";
}
if (props.url.includes("youtu")) {
    type.value = "youtube";
}

const wrapper = ref(null);
const plyr = ref(null);
const playing = ref(false);

const handlePlay = () => {
    console.log("play");
    playing.value = true;
    //@ts-ignore
    if (wrapper.value.classList.contains("unsnapped")) {
        //@ts-ignore
        wrapper.value.classList.remove("snapped");
    }
};
const handlePause = () => {
    console.log("pause");

    playing.value = false;
    //@ts-ignore
    if (wrapper.value.classList.contains("unsnapped")) {
        //@ts-ignore
        wrapper.value.classList.add("snapped");
    }
};

const options = computed(() => {
    return { poster: poster?.value ?? null, controls: ["play-large", "play", "progress", "current-time", "mute", "volume", "fullscreen"] };
});

const isIphone = computed(() => {
    return (
        ["iPhone Simulator", "iPhone", "iPod"].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
});

const __returned__ = { props, poster, type, wrapper, plyr, playing, handlePlay, handlePause, options, isIphone }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})